import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { currentUrl } from "../../url";

export const subscriptionApi = createApi({
    reducerPath: "subscriptionApi",
    tagTypes: ["Subscription"],
    baseQuery: fetchBaseQuery({
        baseUrl: currentUrl,
        prepareHeaders: (headers) => {
            // Читаем токен при каждом запросе, чтобы использовать актуальное значение
            const accessToken = localStorage.getItem("accessToken")
            if (accessToken) {
                // Убеждаемся, что токен имеет правильный формат (Bearer префикс)
                const token = accessToken.startsWith("Bearer ") 
                    ? accessToken 
                    : `Bearer ${accessToken}`
                headers.set("Authorization", token)
                headers.set("Accept", "application/json")
            }
            return headers
        },
    }),
    endpoints: (build) => ({
        getSubscriptionStatus: build.query({
            query: () => `/merchant/subscription-status`,
            providesTags: ["Subscription"]
        }),
    }),
})

export const { useGetSubscriptionStatusQuery } = subscriptionApi;

